'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _projectDragItemTypes = require('../projectDragItemTypes');

var _projectDragItemTypes2 = _interopRequireDefault(_projectDragItemTypes);

var _reactDnd = require('react-dnd');

var _reactOnclickout = require('react-onclickout');

var _reactOnclickout2 = _interopRequireDefault(_reactOnclickout);

var _reactDndHtml5Backend = require('react-dnd-html5-backend');

var _shallowequal = require('shallowequal');

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _NodeViewContent = require('./NodeViewContent');

var _NodeViewContent2 = _interopRequireDefault(_NodeViewContent);

var _NodeViewMenu = require('./NodeViewMenu');

var _NodeViewMenu2 = _interopRequireDefault(_NodeViewMenu);

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _raf = require('raf');

var _raf2 = _interopRequireDefault(_raf);

var _hotkeys = require('./hotkeys');

var _reactHotkeys = require('react-hotkeys');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* injects from baggage-loader */
var styles = require('./NodeView.pcss');

var shallowEqualCustomizer = function shallowEqualCustomizer(value) {
  if (typeof value === 'function') return true;
};

var isBright = function isBright(color) {
  return (0, _color2.default)(color).light();
};

var nodeSource = {
  beginDrag: function beginDrag(props) {
    var id = props.id;

    props.onBeginDrag(id);
    return { id: id };
  },
  endDrag: function endDrag(props, monitor, component) {
    props.onEndDrag(component.props.id);

    if (!monitor.didDrop()) {
      var _component$props = component.props;
      var x = _component$props.x;
      var y = _component$props.y; // get original props!

      component.props.onPositionUpdate({ x: x, y: y });
      return true;
    }

    var result = monitor.getDropResult();
    if (result.type === _projectDragItemTypes2.default.NODE) {
      component.props.onEdgeConnectionRequest(result.id);
      return true;
    }

    return true;
  }
};

function collectSource(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
    draggedNode: monitor.getItem()
  };
}
var nodeTarget = {
  hover: function hover(props) {
    return { id: props.id };
  },
  canDrop: function canDrop(props, monitor) {
    var item = monitor.getItem();
    return item.id !== props.id && props.canBeDropTarget;
  },
  drop: function drop(props) {
    return { type: _projectDragItemTypes2.default.NODE, id: props.id };
  }
};

function collectTarget(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isNodeOver: monitor.isOver()
  };
}

var NodeView = (_dec = (0, _reactDnd.DragSource)(_projectDragItemTypes2.default.NODE, nodeSource, collectSource), _dec2 = (0, _reactDnd.DropTarget)(_projectDragItemTypes2.default.NODE, nodeTarget, collectTarget), _dec(_class = _dec2(_class = function (_Component) {
  _inherits(NodeView, _Component);

  function NodeView(props) {
    _classCallCheck(this, NodeView);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(NodeView).call(this, props));

    _this.state = {
      noPointerEvents: false,
      mouseInside: false,
      menuOpen: false,
      editingCaption: false,
      colorPickerOpen: false
    };
    return _this;
  }

  _createClass(NodeView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.connectDragPreview((0, _reactDndHtml5Backend.getEmptyImage)(), { captureDraggingState: true }); // remove preview

      if (this.props.editOnMount) {
        this.startEditingContent();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      // checks only for shallow equality of props and state
      return !(0, _shallowequal2.default)(nextProps, this.props, shallowEqualCustomizer) || !(0, _shallowequal2.default)(nextState, this.state);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      var _this2 = this;

      var _props = this.props;
      var wasDragging = _props.isDragging;
      var wasNodeOver = _props.isNodeOver;
      var isDragging = nextProps.isDragging;
      var isNodeOver = nextProps.isNodeOver;


      if (!wasDragging && isDragging) {
        (0, _raf2.default)(function () {
          return _this2.setState({ noPointerEvents: true });
        }); // enable dropping the node on another
      }

      if (!isDragging && this.state.noPointerEvents) {
        this.setState({ noPointerEvents: false });
      }

      if (!isDragging && wasDragging) {
        (0, _raf2.default)(function () {
          return _this2.handleMouseEnter();
        });
        setTimeout(function () {
          if (_this2.state.mouseInside) _this2.handleMouseLeave();
        }, 800);
      }

      if (isDragging) {
        this.closeMenu();
      }

      if (!wasNodeOver && isNodeOver) {
        this.props.onNodeOver();
      }
      if (wasNodeOver && !isNodeOver) {
        this.props.onNodeOverStop();
      }
    }
  }, {
    key: 'getHotKeyHandlers',
    value: function getHotKeyHandlers() {
      var _this3 = this,
          _ref;

      return _ref = {}, _defineProperty(_ref, _hotkeys.APPEND_RIGHT_CONNECTED, function (ev) {
        ev.preventDefault();
        _this3.props.onAppendRightConnected();
      }), _defineProperty(_ref, _hotkeys.APPEND_RIGHT, function (ev) {
        ev.preventDefault();
        _this3.props.onAppendRight();
      }), _defineProperty(_ref, _hotkeys.APPEND_BOTTOM_CONNECTED, function (ev) {
        ev.preventDefault();
        _this3.props.onAppendBottomConnected();
      }), _ref;
    }
  }, {
    key: 'openMenu',
    value: function openMenu() {
      var _this4 = this;

      (0, _raf2.default)(function () {
        return _this4.setState({ colorPickerOpen: false, menuOpen: true });
      });
    }
  }, {
    key: 'closeMenu',
    value: function closeMenu() {
      this.setState({ menuOpen: false });
    }
  }, {
    key: 'handleMouseEnter',
    value: function handleMouseEnter() {
      if (this.props.isDragging || this.state.mouseInside) return; // prevent lags

      this.setState({ mouseInside: true });
      if (this.props.onHover) this.props.onHover();
    }
  }, {
    key: 'handleMouseLeave',
    value: function handleMouseLeave() {
      this.setState({ mouseInside: false });
      if (this.props.onHoverStop) this.props.onHoverStop();
    }
  }, {
    key: 'handleClickOut',
    value: function handleClickOut() {
      if ((this.state.mouseInside || this.state.menuOpen || this.state.colorPickerOpen) && !this.isDraggingSelf()) {
        this.closeMenu();
        this.setState({ mouseInside: false, colorPickerOpen: false });
      }
    }
  }, {
    key: 'handleCaptionEditStart',
    value: function handleCaptionEditStart() {
      this.setState({ editingCaption: true });
    }
  }, {
    key: 'handleCaptionEdit',
    value: function handleCaptionEdit(newCaption) {
      this.props.onCaptionUpdated(newCaption);
      this.setState({ editingCaption: false });
      this.handleMouseLeave();
    }
  }, {
    key: 'startEditingContent',
    value: function startEditingContent() {
      if (this.refs.nodeContent) {
        this.refs.nodeContent.startEdit();
        this.setState({ editingCaption: true });
      }
    }
  }, {
    key: 'handleMenuRenameClick',
    value: function handleMenuRenameClick() {
      this.startEditingContent();
      this.closeMenu();
    }
  }, {
    key: 'handleMenuColorClick',
    value: function handleMenuColorClick() {
      // this.closeMenu();
      this.setState({ colorPickerOpen: true });
    }
  }, {
    key: 'handleMenuRemoveClick',
    value: function handleMenuRemoveClick() {
      this.props.onRemove();
      this.closeMenu();
    }
  }, {
    key: 'handleMenuOpenClick',
    value: function handleMenuOpenClick() {
      this.props.onPreview();
      this.closeMenu();
    }
  }, {
    key: 'handleColorPick',
    value: function handleColorPick(color) {
      this.props.onColorUpdate(color);
      this.handleClickOut();
    }
  }, {
    key: 'handleMenuDetachClick',
    value: function handleMenuDetachClick() {
      this.props.onDetach();
      this.closeMenu();
    }
  }, {
    key: 'handleMenuAppendNewClick',
    value: function handleMenuAppendNewClick() {
      this.props.onAppendNew();
      this.closeMenu();
    }
  }, {
    key: 'isDraggingSelf',
    value: function isDraggingSelf() {
      var _props2 = this.props;
      var id = _props2.id;
      var isDragging = _props2.isDragging;
      var draggedNode = _props2.draggedNode;

      if (!draggedNode || !isDragging) return false;

      return isDragging && draggedNode && draggedNode.id === id;
    }
  }, {
    key: 'handleClick',
    value: function handleClick(ev) {
      var _props3 = this.props;
      var isPreviewing = _props3.isPreviewing;
      var onPreview = _props3.onPreview;
      var disableModifications = _props3.disableModifications;


      if (this.state.editingCaption) {
        ev.preventDefault();
        return;
      }

      if (isPreviewing && !disableModifications) {
        ev.stopPropagation();
        this.startEditingContent();
      } else {
        ev.stopPropagation();
        onPreview();
      }
    }
  }, {
    key: 'handleBoundingRectUpdate',
    value: function handleBoundingRectUpdate(rect) {
      this.props.onBoundingRectUpdated(rect);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props;
      var id = _props4.id;
      var x = _props4.x;
      var y = _props4.y;
      var caption = _props4.caption;
      var color = _props4.color;
      var isDragging = _props4.isDragging;
      var isNodeOver = _props4.isNodeOver;
      var connectDropTarget = _props4.connectDropTarget;
      var connectDragSource = _props4.connectDragSource;
      var canBeDropTarget = _props4.canBeDropTarget;
      var disableModifications = _props4.disableModifications;
      var _state = this.state;
      var mouseInside = _state.mouseInside;
      var menuOpen = _state.menuOpen;
      var editingCaption = _state.editingCaption;
      var colorPickerOpen = _state.colorPickerOpen;
      var noPointerEvents = _state.noPointerEvents;

      var draggingSelf = this.isDraggingSelf();

      // const light = isBright(color) || (mouseInside && !editingCaption) || menuOpen || colorPickerOpen;

      var stylesProps = {
        nodeOver: isNodeOver && !draggingSelf,
        canBeDropTarget: canBeDropTarget,
        expanded: !disableModifications && (mouseInside || menuOpen || colorPickerOpen || isDragging),
        menuOpen: menuOpen, colorPickerOpen: colorPickerOpen,
        dragging: isDragging,
        editingCaption: editingCaption,
        /* highlightColor: (mouseInside || menuOpen || colorPickerOpen || isDragging) && !editingCaption, */
        highlightColor: false,
        light: isBright(color)
      };

      var dataProps = {
        id: id, caption: caption, color: color
      };

      var eventProps = {
        onBoundingRectUpdated: this.handleBoundingRectUpdate.bind(this),

        onMenuOpen: this.openMenu.bind(this),
        onMouseEnter: this.handleMouseEnter.bind(this),
        onMouseLeave: this.handleMouseLeave.bind(this),
        onClick: this.handleClick.bind(this),

        onCaptionEditStart: this.handleCaptionEditStart.bind(this),
        onCaptionEdit: this.handleCaptionEdit.bind(this),

        onBeginDragSubtree: this.props.onBeginDragSubtree,
        onEndDragSubtree: this.props.onEndDragSubtree,

        connectDragSource: connectDragSource,
        disableModifications: disableModifications
      };

      var containerClassName = (0, _classnames2.default)(styles.container, isDragging && styles.dragging, noPointerEvents && styles.noPointerEvents, (menuOpen || mouseInside) && styles.lifted);

      var Content = _react2.default.createElement(
        'div',
        { className: styles.node },
        _react2.default.createElement(_NodeViewContent2.default, _extends({
          ref: 'nodeContent'
        }, dataProps, stylesProps, eventProps)),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(styles.dropdownMenu, this.props.menuOpen && styles.menuOpen) },
          _react2.default.createElement(
            'div',
            { className: styles.menuContent },
            _react2.default.createElement(_NodeViewMenu2.default, {
              nodeId: id,

              onClose: this.closeMenu.bind(this),
              isOpen: menuOpen,
              isColorPickerOpen: colorPickerOpen,

              onColorPick: this.handleColorPick.bind(this),
              onMenuOpenClick: this.handleMenuOpenClick.bind(this),
              onMenuRenameClick: this.handleMenuRenameClick.bind(this),
              onMenuColorClick: this.handleMenuColorClick.bind(this),
              onMenuRemoveClick: this.handleMenuRemoveClick.bind(this),
              onMenuDetachClick: this.handleMenuDetachClick.bind(this),
              onMenuAppendNewClick: this.handleMenuAppendNewClick.bind(this)
            })
          )
        )
      );

      var result = _react2.default.createElement(
        _reactOnclickout2.default,
        { onClickOut: this.handleClickOut.bind(this) },
        _react2.default.createElement(
          'div',
          {
            style: { transform: 'translate(-50%, -50%) translate(' + x + 'px, ' + y + 'px)' },
            className: containerClassName
          },
          _react2.default.createElement(
            _reactHotkeys.HotKeys,
            { keyMap: _hotkeys.KEY_MAP, handlers: this.getHotKeyHandlers() },
            this.props.disableModifications ? Content : connectDropTarget(Content)
          )
        )
      );

      return result;
    }
  }]);

  return NodeView;
}(_react.Component)) || _class) || _class);
exports.default = NodeView;


NodeView.propTypes = {
  x: _react.PropTypes.number.isRequired,
  y: _react.PropTypes.number.isRequired,
  caption: _react.PropTypes.string.isRequired,
  color: _react.PropTypes.string.isRequired,

  isNodeBeingDragged: _react.PropTypes.bool,
  isDragging: _react.PropTypes.bool,
  connectDragSource: _react.PropTypes.func,
  connectDragPreview: _react.PropTypes.func,

  onNodeOver: _react.PropTypes.func.isRequired,
  onNodeOverStop: _react.PropTypes.func.isRequired,

  id: _react.PropTypes.string.isRequired,

  onPositionUpdate: _react.PropTypes.func.isRequired,
  onCaptionUpdated: _react.PropTypes.func.isRequired,
  onBoundingRectUpdated: _react.PropTypes.func.isRequired,

  onHover: _react.PropTypes.func.isRequired,
  onHoverStop: _react.PropTypes.func.isRequired,
  onRemove: _react.PropTypes.func.isRequired,
  onPreview: _react.PropTypes.func.isRequired,
  onDetach: _react.PropTypes.func.isRequired,
  onAppendNew: _react.PropTypes.func.isRequired,
  onAppendRightConnected: _react.PropTypes.func.isRequired,
  onAppendRight: _react.PropTypes.func.isRequired,
  onAppendBottomConnected: _react.PropTypes.func.isRequired,

  onColorUpdate: _react.PropTypes.func.isRequired,

  onEdgeConnectionRequest: _react.PropTypes.func.isRequired,
  canBeDropTarget: _react.PropTypes.bool,

  editOnMount: _react.PropTypes.bool
};


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectView/NodeView/NodeView.js
// module id = 595
// module chunks = 1